import { canUseDOM } from '../../components';

export const FETCH_AGENCY_HOME_CLIENT = 'FETCH_AGENCY_HOME_CLIENT';
export const FETCH_AGENCY_HOME = 'FETCH_AGENCY_HOME';
export const FETCH_AGENCY_HOME_START = 'FETCH_AGENCY_HOME_START';
export const FETCH_AGENCY_HOME_SUCCESS = 'FETCH_AGENCY_HOME_SUCCESS';
export const FETCH_AGENCY_HOME_ERROR = 'FETCH_AGENCY_HOME_ERROR';

export const FETCH_AVAILABLE_RESULTS_AGENCY = 'FETCH_AVAILABLE_RESULTS_AGENCY';
export const FETCH_AVAILABLE_RESULTS_AGENCY_START = 'FETCH_AVAILABLE_RESULTS_AGENCY_START';
export const FETCH_AVAILABLE_RESULTS_AGENCY_SUCCESS = 'FETCH_AVAILABLE_RESULTS_AGENCY_SUCCESS';
export const FETCH_AVAILABLE_RESULTS_AGENCY_ERROR = 'FETCH_AVAILABLE_RESULTS_AGENCY_ERROR';

const fetchFn = (fetch, url, verb, params) => fetch(url, {
  method: verb,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Connection: 'keep-alive',
  },
  body: JSON.stringify(params),
  credentials: 'same-origin',
});

export function fetchAgencyHome(params) {
  if (canUseDOM) {
    return () => ({
      type: FETCH_AGENCY_HOME_CLIENT,
    });
  }
  const url = '/portal-srp/api/v1/agency';
  const verb = 'POST';
  const body = {
    site: params.apireq.site, domain: params.domain, locale: params.locale, apireq: params.apireq, 
  };
  return ({ fetch }) => ({
    type: FETCH_AGENCY_HOME,
    payload: {
      promise: fetchFn(fetch, url, verb, body)
        .then(response => response.json())
        .catch(err => console.error('error', err)),
    },
  });
}


const fetchAvailableResultsAgencyFn = (fetch, verb, params) => fetch('/portal-srp/api/v1/agency/availableresultsagency', {
  method: verb,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Connection: 'keep-alive',
  },
  body: JSON.stringify(params),
  credentials: 'same-origin',
});

export function fetchAvailableResultsAgency(params) {
  return ({ fetch }) => ({
    type: FETCH_AVAILABLE_RESULTS_AGENCY,
    payload: {
      search: 'something',
      promise: fetchAvailableResultsAgencyFn(fetch, 'POST', params)
        .then(response => response.json())
        .catch(err => console.log('error agency fetch', err)),
    },
  });
}
